import React from 'react';
import { useTranslation } from 'react-i18next';
import Countdown from './Countdown';
import './Home.css';

const Home = () => {
    const { t } = useTranslation();

    return (
        <section id="introduction" className="hero-section">
            <div className="hero-content">
                <h2 className="hero-title">{t('join_us_title')}</h2>
                <p className="hero-subtitle">{t('join_us_text')}</p>
                <Countdown />
            </div>
        </section>
    );
};

export default Home;
